import Vue from 'vue'
import App from './App.vue'
import router from "./routes"
import "./assets/style/reset.css";
// import "./assets/style/global.css";

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

// Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router,
}).$mount('#app')

